import { Action, PayloadAction } from "@reduxjs/toolkit";
import { FileProperties } from "@store/data/types";
import { ProviderDefinition, WorkerStatus, ProviderFile } from "fileParsing/types";

// State definition
export type FileState = {
  readonly file: FileStatus[];

  readonly lastFilename: string;
  readonly sampleDatasetId: number;
};

export type FileStatus = {
  id: string;
  file: File;
  loading: boolean;
  error: string | null;
  progress: number;
};

// Action types definition
export enum FileDropActionTypes {
  FILE_ADD = "@@files/FILE_DROP_ADD",
  ITER_START = "@@files/ITER_START",
  ITER_FILES = "@@files/FILE_DROP_FILES",
  ITER_PROGRESS = "@@files/FILE_DROP_PROGRESS",
  ITER_SUCCESS = "@@files/FILE_SUCCESS",
  ITER_SUCCESS_SAMPLE = "@@files/SAMPLE_SUCCESS",
  ITER_FAILURE = "@@files/FILE_DROP_FAILURE",
  RESET_STATE = "@@files/RESET_STATE",
  CLEAR_ERROR = "@@files/CLEAR_ERROR",
  CLEAR_FILENAME = "@@files/CLEAR_FILENAME",
}

export type WorkerMessage =
  | StartDataProvider
  | ParserDataProvider
  | ParserDataProgress
  | ParserDataSuccess
  | ParserDataFailure
  | ParserDataLog
  | ParserDataWarn;

type StartDataProvider = {
  type: WorkerStatus.Start;
  file: File;
};
type ParserDataProvider = {
  type: WorkerStatus.Provider;
  message: ProviderDefinition;
};
type ParserDataProgress = {
  type: WorkerStatus.Progress;
  message: number;
};
type ParserDataSuccess = {
  type: WorkerStatus.Success;
  message: {
    data: {
      values: ProviderFile[];
      provider: ProviderDefinition;
    };
    id: string;
    name: string;
  };
};
type ParserDataFailure = {
  type: WorkerStatus.Failure;
  message: string;
};
type ParserDataLog = {
  type: WorkerStatus.Log;
  message: string;
};
type ParserDataWarn = {
  type: WorkerStatus.Warn;
  message: string;
};

type FileAddAction = PayloadAction<File[], FileDropActionTypes.FILE_ADD>;
type IterStartAction = PayloadAction<{ id: string }, FileDropActionTypes.ITER_START>;
type IterFilesAction = Action<FileDropActionTypes.ITER_FILES>;
type IterProgressAction = PayloadAction<{ id: string; progress: number }, FileDropActionTypes.ITER_PROGRESS>;
type IterSuccessAction = PayloadAction<
  { id: string; fileProperties: FileProperties },
  FileDropActionTypes.ITER_SUCCESS
>;
type IterSuccessSampleAction = Action<FileDropActionTypes.ITER_SUCCESS_SAMPLE>;
type IterFailureAction = PayloadAction<{ id: string; msg: string }, FileDropActionTypes.ITER_FAILURE>;
type ResetStateAction = Action<FileDropActionTypes.RESET_STATE>;
type ClearErrorAction = Action<FileDropActionTypes.CLEAR_ERROR>;
type ClearFilenameAction = Action<FileDropActionTypes.CLEAR_FILENAME>;

export type FileActions =
  | FileAddAction
  | IterStartAction
  | IterFilesAction
  | IterProgressAction
  | IterSuccessAction
  | IterSuccessSampleAction
  | IterFailureAction
  | ResetStateAction
  | ClearErrorAction
  | ClearFilenameAction;
